__turbopack_context__.v({
  "lineClamp": "MNuygW_lineClamp",
});
